import { cn } from '@/shared/utils/cn'

interface CountBadgeProps {
  count: number
  className?: string
}

export function CountBadge({ count, className }: CountBadgeProps) {
  if (count <= 0) {
    return null
  }

  return (
    <span
      className={cn(
        'rounded-full bg-[var(--color-accent)]/15 px-1.5 text-xs font-semibold text-[var(--color-accent)]',
        className,
      )}
    >
      {count}
    </span>
  )
}
